import { useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { getParamAsInt } from "../../app/utils";
import AlertMessage, { AlertLevel } from "../../components/AlertMessage";
import { Loading } from "../../components/Loading";
import { ClassLinkOrCleverIconWithTooltip } from "../../components/ClassLinkOrCleverIcon";
import { useGetDistrictInfoQuery } from "./districtsApiSlice";
import DistrictSettingsSection from "./addEdit/sections/DistrictSettingsSection";
import DistrictInfoSection from "./addEdit/sections/DistrictInfoSection";
import DistrictSchoolsSection from "./addEdit/sections/DistrictSchoolsSection";
import DistrictAdminsSection from "./addEdit/sections/DistrictAdminsSection";

export default function EditDistrict() {
	const [queryParams] = useSearchParams();
	const { config } = useAppSelector((state) => state.site);
	const districtId = getParamAsInt(queryParams, "districtId");

	const [errorMessage, setErrorMessage] = useState("");

	const { data: districtInfo, isLoading } = useGetDistrictInfoQuery(districtId!, {
		skip: !districtId,
	});

	const location = useLocation();
	const returnTo = location.state?.returnTo as string;

	const tooltipContent = districtInfo?.cleverID
		? "This district has a Clever account"
		: districtInfo?.classLinkID
			? "This district has a ClassLink account"
			: undefined;

	return (
		<section>
			<h1>Manage District</h1>
			<Loading loading={isLoading} />
			{districtInfo && districtId && (
				<section>
					<div className="flex mt-6 gap-x-3 items-center">
						{(districtInfo.cleverID || districtInfo.classLinkID) &&
							!config?.isUtahComposeSite && (
								<ClassLinkOrCleverIconWithTooltip
									isClassLinkEntity={!!districtInfo.classLinkID}
									isCleverEntity={!!districtInfo.cleverID}
									iconClasses="size-10"
									tooltipId="outside-site-icon-tooltip"
									tooltipContent={tooltipContent}
								/>
							)}
						<h2>{districtInfo.name}</h2>
					</div>
					<AlertMessage
						className="mt-4 text-sm"
						type={AlertLevel.Error}
						message={errorMessage}
						showIcon={true}
					/>
					<DistrictSettingsSection
						districtInfo={districtInfo}
						setErrorMessage={setErrorMessage}
					/>
					<DistrictInfoSection districtInfo={districtInfo} returnTo={returnTo} />
					<DistrictSchoolsSection districtId={districtId} />
					<DistrictAdminsSection districtId={districtId} />
				</section>
			)}
		</section>
	);
}
